import React from 'react';
import DateTimePickerFilter from './components/DateTimePickerFilter';
import { IFilterDrawerSchema, ISelectedOptions } from './types';
import { FilterType } from './constants';

const ComponentMap = {
  [FilterType.DATE_TIME_PICKER]: DateTimePickerFilter
};

interface IQuestionRenderingEngine {
  filterType: string;
  filterKey: string;
  filterSchema: Record<string, IFilterDrawerSchema>;
  selectedOptions: ISelectedOptions;
  setSelectedOptions: (selectedOptions: ISelectedOptions) => void;
}

const FilterRenderingEngine: React.FC<IQuestionRenderingEngine> = props => {
  const Comp = ComponentMap[props.filterType as FilterType];
  if (!Comp) {
    return null;
  }
  return (
    <div>
      <Comp {...props} />
    </div>
  );
};

export default FilterRenderingEngine;
